export const fixInputSx = {
  '& .MuiInputLabel-outlined': {
    transform: 'translate(14px, 13px) scale(1) !important',
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    transform: 'translate(14px, -9px) scale(0.75) !important',
  },
}

export const fixInputSxWithCustomColor = (
  labelColor: string | undefined,
  labelColorFocused: string | undefined,
  borderColor: string | undefined,
  borderColorFocused: string | undefined,
) => ({
  '& .MuiInputLabel-outlined': {
    ...(labelColor && { color: labelColor }),
    transform: 'translate(14px, 13px) scale(1) !important',
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    ...(labelColorFocused && { color: labelColorFocused }),
    transform: 'translate(14px, -9px) scale(0.75) !important',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      ...(borderColor && { borderColor }),
    },
    '&.Mui-focused fieldset': {
      ...(borderColorFocused && { borderColor: borderColorFocused }),
    },
  },
})
